import { render, staticRenderFns } from "./LessonsEdit.vue?vue&type=template&id=50fd2242&scoped=true&"
import script from "./LessonsEdit.vue?vue&type=script&lang=js&"
export * from "./LessonsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd2242",
  null
  
)

export default component.exports